<div class="">
    <div class="text-lg" mat-dialog-title>Add To Calendar</div>
    <mat-dialog-content>
    <div class="text-lg font-body mb-4">YOU’RE ALL SET!</div>
    <div class="text-base font-body mb-4">
        Your self tour for {{model.AddressShort}} is scheduled for {{model.DateTitle}}  
    </div>
    <div id="selftour-cal-anchor"></div>
    <div class="w-full font-body">
      <button mat-flat-button color="primary" class=" w-full my-4 font-normal text-2xl sm:text-base" [mat-dialog-close]="true"  (click)="finish()">FINISHED</button>
    </div>
    </mat-dialog-content>
</div>
  